(() => {
  'use strict';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-builder]').forEach(builder => {
      if (builder.dataset.ready) return;
      builder.dataset.ready = 'true';
      const rows = [...builder.querySelectorAll('[data-part]')];
      const button = builder.querySelector('[data-add-parts]');
      const status = builder.querySelector('[data-status]');
      const currency = builder.dataset.currency || 'EUR';
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(value / 100);
      let busy = false;
      const selected = () => rows.filter(row => row.querySelector('[data-pick]').checked).map(row => {
        const variantControl = row.querySelector('[data-variant]');
        const option = variantControl.tagName === 'SELECT' ? variantControl.selectedOptions[0] : variantControl;
        const quantity = row.querySelector('[data-quantity]');
        const price = Number.parseFloat(option.dataset.price);
        const amount = Number(quantity.value);
        return { id: option.value, quantity: amount, price: Number.isFinite(price) ? price : 0, valid: !option.disabled && Number.isFinite(price) && quantity.checkValidity() && Number.isSafeInteger(amount) && amount > 0 };
      });
      const update = () => {
        const items = selected();
        builder.querySelector('[data-total]').textContent = money(items.reduce((sum,item) => sum + (item.valid ? item.price * item.quantity : 0), 0));
        builder.querySelector('[data-selected-count]').textContent = items.reduce((sum,item) => sum + (item.valid ? item.quantity : 0), 0);
        button.disabled = busy || !items.length || items.some(item => !item.valid);
      };
      builder.addEventListener('change', event => {
        if (event.target.matches('select[data-variant]')) {
          const row = event.target.closest('[data-part]');
          const option = event.target.selectedOptions[0];
          const quantity = row.querySelector('[data-quantity]');
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          if (!quantity.checkValidity()) quantity.value = quantity.min;
        }
        status.textContent = ''; update();
      });
      builder.addEventListener('input', update);
      button.addEventListener('click', async () => {
        const items = selected();
        if (busy || !items.length || items.some(item => !item.valid)) return;
        // Merge repeated variants to avoid ambiguous quantities in Shopify's batch API.
        const combined = new Map();
        items.forEach(({id,quantity}) => combined.set(id,(combined.get(id) || 0) + quantity));
        busy = true; update(); status.textContent = 'Adding your parts…';
        try {
          const response = await fetch(builder.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...combined].map(([id,quantity])=>({id,quantity}))})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Some parts could not be added. Check your cart before trying again.');
          window.location.assign(builder.dataset.cartUrl);
        } catch (error) {
          status.textContent = (error.message === 'Failed to fetch' ? 'The connection was interrupted. Check your cart before retrying to avoid duplicate items.' : error.message) + ' ';
          const link = document.createElement('a'); link.href = builder.dataset.cartUrl; link.textContent = 'Review cart'; status.append(link);
          busy = false; update();
        }
      });
      update();
    });
    scope.querySelectorAll('[data-product-variant]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        // Server-render the selected variant, price and quantity rules together.
        const url = new URL(window.location.href); url.searchParams.set('variant',select.value); window.location.assign(url.href);
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('.product-detail');
    if (detail) detail.open = true;
  });
})();
